import { createGlobalStyle } from "styled-components";
import { defaultFont } from "src/nhweb-shared/theme/fonts";

const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
  }

  html, body, #index {
    height: 100%;
    overflow: hidden;
  }

  body {
    font-family: ${defaultFont};
    margin: 0;
    overscroll-behavior-y: contain;
  }

  body.impact-report-route #index {
    overflow: auto;
  }
`;

export default GlobalStyle;
